<template>
  <div class="page" id="mixed-notes">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" background-color="#EBF9FF" color="#02B99E">
    </loading>
    <div class="decorative-texture top">
      <img :src="require(`@/assets/img/texture.png`)" />
    </div>
    <div class="decorative-texture position-bottom movil-only">
      <img :src="require(`@/assets/img/texture.png`)" />
    </div>
    <vue-snotify></vue-snotify>
    <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>
    <mnavbar @menuVisible="menuVisible"></mnavbar>
    <div id="page-content-wrapper">
      <div class="container-fluid noPadding">
        <div class="toolBar">
          <div class="row">
            <div class="col">
              <h2 class="toolBarTitle">Newsletter</h2>
            </div>
          </div>
        </div>
        <div class="row justify-content-center m-2">
          <div class="col-sm-12 col-md-10 col-lg-10 col-xl-7">
            <!-- <section class="noPadding"> -->
            <div class="iframe-container">
              <section class="noPadding">
                <div class="row justify-content-center" style="margin-top: 2%">
                  <div class="col-sm-12 col-md-11 col-lg-10">
                    <div class="card head-card keywords-section">
                      <div class="title-card">
                        <h4>NewsLetter</h4>
                      </div>

                      <div class="card-content">
                        <div class="row justify-content-center">
                          <div class="col-sm-12 col-md-8 mb-1 justify-content-center"
                            v-if="form.url != '' && form.url != null">
                            <img v-if="form.url != '' && form.url != null" id="imagen" :src="form.url" width="40%"
                              height="70%" alt="Imagen" />
                          </div>

                          <div class="col-sm-12 col-md-8 mb-2">
                            <div class="inputype Keywords-input">
                              <form>
                                <h4 class="interiorTitle">Logo</h4>
                                <h5 class="interiorTitle">Formatos aceptados: PNG y JPG, dimensiones máximas: 412 x 128
                                  pixeles.
                                </h5>
                                <input id="logoNewsletter" type="file" accept="image/png, image/jpg, image/jpeg"
                                  placeholder="Logo" @input="uploadImage" />
                              </form>
                            </div>
                          </div>

                          <div class="col-sm-12 col-md-8 mb-2">
                            <div class="inputype Keywords-input">
                              <form>
                                <h4 class="interiorTitle">Titulo</h4>
                                <input type="text " v-model="form.titulo" placeholder="Titulo" />
                              </form>
                            </div>
                          </div>

                          <div class="col-sm-12 col-md-8 mb-2">
                            <div class="inputype Keywords-input">
                              <form>
                                <h4 class="interiorTitle">
                                  Fondo del documento
                                </h4>
                                <input :style="'background-color:' +
                                  form.color +
                                  '; border: 2px solid ' +
                                  form.color
                                  " id="color-picker" type="color" v-model="form.color" placeholder="Color"
                                  @input="updateColor" />
                              </form>
                            </div>
                          </div>

                          <div class="col-sm-12 col-md-8 mb-2">
                            <div class="row justify-content-center">
                              <div class="col-sm-6 col-md-6 mb-2">
                                <div class="Keywords-button-container">
                                  <button :class="[
                                      'button',
                                      'fluid',
                                      'alternative',
                                      'noMargin',
                                    ]" @click="guardarCambios()">
                                    Guardar
                                  </button>
                                </div>
                              </div>
                              <div class="col-sm-6 col-md-6 mb-2">
                                <div class="Keywords-button-container">
                                  <button :class="[
                                      'button',
                                      'fluid',
                                      'alternative',
                                      'noMargin',
                                    ]" @click="generar_pdf">
                                    Generar PDF
                                  </button>
                                </div>
                              </div>

                              <div class="col-sm-6 col-md-6 mb-2">
                                <div class="Keywords-button-container">
                                  <button :class="[
                                      'button',
                                      'fluid',
                                      'alternative',
                                      'noMargin',
                                    ]" @click="abrir">
                                    Vista previa
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <!-- </section> -->
          </div>
          <div class="col-lg-10 col-sm-12 col-md-12 col-xs-12">
            <timeline from="folder" :items="noticias" :LastEvaluatedKey="0" @goToNoteTimeline="goToNote"
              @loadMore="loadMore" @borrar="showModalDelete" :actualizarList="actualizarList"></timeline>
          </div>
        </div>
      </div>
    </div>
    <vistaPrevia v-if="url_pdf != ''" :active="mostrarModal" :close="showCloseModal" :url="url_pdf"></vistaPrevia>
    <confirm-modal smsModal="Realmente, ¿Desea eliminar ésta nota de newsletter?" :show="showModal" @cancelar="hideModal"
      @aceptar="borrar"></confirm-modal>
  </div>
</template>

<script>
import confirmModal from "@/components/confirm";
import SideMenu from "@/components/sideMenu";
import mnavbar from "@/components/mnavbar";
// import panelNotas from "@/components/panelNotas";
import timeline from "./components/timelinenewsletter.vue";
import vistaPrevia from "./components/vistaPrevia.vue";
export default {
  components: {
    SideMenu,
    mnavbar,
    confirmModal,
    // panelNotas,
    timeline,
    vistaPrevia,
  },
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      api: "https://4x5kpq7d6g.execute-api.us-east-1.amazonaws.com/v2/getnewsletter",
      iframeUrl: "http://localhost:8082",
      menuOn: false,
      form: {
        titulo: "",
        color: "#ffffff",
        file: null,
        url: "",
        key: this.$store.state.userInfo.id,
        height: 0,
        width: 0,
      },
      defaultForm: {
        titulo: "",
        color: "#ffffff",
        file: null,
        url: "",
        key: this.$store.state.userInfo.id,
        height: 0,
        width: 0,
      },
      noticias: [],
      view: 1,
      LastEvaluatedKey: 1,
      isLoading: false,
      mostrarModal: false,
      url_pdf: "",
      showModal: false,
      noticiaD: null,
      imagenSelect: null,
    };
  },
  mounted() {
    console.log(this.$store.state.userInfo);
    this.get_newsletter();
  },
  methods: {
    menuVisible(menu) {
      this.hide = true;
      this.menuOn = menu;
    },
    updateColor(event) {
      this.form.color = event.target.value;
    },
    uploadImage(event) {
      const imagen = event.target.files[0];

      if (imagen) {
        const fileExtension = imagen.name.split(".").pop();
       
        // this.form.file = imagen;
        if (fileExtension == "png" || fileExtension == "jpg" || fileExtension == "jpeg") {
          const reader = new FileReader();

          reader.onload = async () => {
            this.form.url = reader.result;
            this.form.file = btoa(reader.result);
            await this.valildDimensiones(this.form.url);
          };

          reader.readAsDataURL(imagen);
        } else {
          document.getElementById("logoNewsletter").value = "";
          this.form.url = null;
          this.form.file = null;
          this.error("Solo se admite formato png, jpg y jpeg");
        }
      }
    },
    async get_newsletter() {
      this.form = Object.assign({}, this.defaultForm);
      document.getElementById("logoNewsletter").value = "";
      this.isLoading = true;
      var post_data = {
        key: this.$store.state.userInfo.id,
        token: this.$store.getters.getToken,
      };
      await axios
        .post(this.api, post_data) //petición
        .then((response) => {
        
          var item = response.data.newsletter;
          if (item) {
            this.form.titulo = item.titulo;
            this.form.url = item.logo;
            this.form.color = item.fondo;
            this.form.width = item.width;
            this.form.height = item.height;
            this.noticias = response.data.notas;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    goToNote(obj) {
    
      var name = "";
      var fi = obj.fi ? obj.fi : obj.entrada;
      switch (fi) {
        case "FB":
        case "I":
        case "TW":
          name = "notaEmbedded"; //este ya esta NotaEmbeddedLayoutDesktop
          break;
        case "Y":
          name = "notaYoutube"; //este ya esta NotaVideoLayoutDesktop
          break;
        case "PD":
          name = "notaText"; //este ya esta notaTextLayoutDesktop
          break;
        case "T":
        case "R":
          name = "notaVideo"; // NotaVideoLayoutDesktop
          break;
      }

      var p = {
        from: "newsletter",
      };
      this.$store.commit("saveBack2", p);

      var params = {
        id: obj.id ? obj.id : obj.key,
        fi: fi,
      };

      this.$router.push({ name: name, params: params });
    },
    goToNotes() { },
    loadMore() { },
    async borrar() {
      var item = this.noticiaD;
   
      this.isLoading = true;
      var post_data = {
        table: this.$store.state.userInfo.id + "_newsletter",
        id: item.item.key,
      };

      await axios
        .post(this.url + "deleteItemNewsletter",
          post_data
        ) //petición
        .then((response) => { })
        .catch(function (error) {
          console.log(error);
        });
      this.hideModal();
      this.isLoading = false;

      this.get_newsletter();
    },
    async generar_pdf(mostrarMessage = true) {
      var query = {
        key: this.$store.state.userInfo.id,
      };
      this.isLoading = true;
      await axios
        .post(this.url + "generar_pdf_newsletter",
          query
        )
        .then((response) => {
          if (response.data.success) {
            this.url_pdf = response.data.link;
            if (mostrarMessage) {
              this.success("Generado correctamente");
              window.open(response.data.link);
            }

            // this.get_newsletter();
          } else {
            if (mostrarMessage) {
              this.error("Intente nuevamente");
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },

    async guardarCambios(mostrarMessage = true) {
      if (this.form.file) {
        const img = new Image();
        img.onload = async () => { };
        img.src = this.form.url;
        console.log(`${img.width} ${img.height}`);
        this.form.width = img.width;
        this.form.height = img.height;
      }
      this.form.lista = this.noticias;
      this.isLoading = true;
      await axios
        .post(this.url + "createeditnewletter",
          this.form
        )
        .then((response) => {
          if (response.data.success) {
            if (mostrarMessage) {
              this.success(response.data.body);
              this.form = Object.assign({}, this.defaultForm);
              // this.get_newsletter();
              location.reload();
            }
          } else {
            if (mostrarMessage) {
              this.error(response.data.body);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    success(msg) {
      this.$snotify.success(msg, this.$store.state.success);
    },
    error(msg) {
      this.$snotify.error(msg, this.$store.state.error);
    },
    showCloseModal() {
      this.mostrarModal = !this.mostrarModal;
      if (!this.mostrarModal) {
        this.url_pdf = "";
      }
      // this.guardarCambios();
    },
    async abrir() {
      await this.vista_previa();
      // this.showCloseModal();
    },
    async vista_previa() {
      if (this.form.file) {
        const img = new Image();
        img.onload = async () => { };
        img.src = this.form.url;
     
        this.form.width = img.width;
        this.form.height = img.height;
      }

      this.isLoading = true;
      var query = this.form;
      (query.lista = this.noticias),
        await axios
          .post(this.url + "vista_previa_newsletter",
            query
          )
          .then((response) => {
            if (response.data.success) {
              this.url_pdf = response.data.url;
              this.showCloseModal();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      this.isLoading = false;
    },
    hideModal() {
      this.showModal = false;
      this.noticiaD = null;
    },
    showModalDelete(itemD) {
      this.noticiaD = itemD;
      this.showModal = true;
    },
    async valildDimensiones(imagen) {
    
      const img = new Image();
      img.onload = async () => {
        await console.log(img.width);
    
        if (img.width > 412 || img.height > 128) {
          document.getElementById("logoNewsletter").value = "";
          this.form.url = null;
          this.form.file = null;
          this.error("El archivo debe tener un tamaño máximo de 412 X 128");
        }
      };
      img.src = imagen;


    },
    actualizarList(newList) {
      this.noticias = newList;
    }
  },
};
</script>
<style scoped>
.keywords-section .Keywords-input input {
  border: 1px solid #00b99e;
}

.keywords-section .Keywords-input input::placeholder {
  color: #062633;
}
</style>